import {
  DatabaseReportAdminViewModel,
  DatabaseReportInputModel,
  ReportParameterInputModel,
  ReportParameterViewModel,
} from '@ail/reports-api'
import React, { Component } from 'react'
import DatePicker from 'react-datepicker'
import { OracleDbType } from '../../../../types/enums'

interface IProps {
  report: DatabaseReportAdminViewModel | DatabaseReportInputModel
  onChange?: (e: ReportParameterViewModel[] | ReportParameterInputModel[]) => void
}

class ReportParameters extends Component<IProps> {
  constructor(props: IProps) {
    super(props)
  }

  render() {
    const parameters = this.props.report.parameters
    return (
      <>
        <div className="box-title">
          <span>
            <i className="icon-settings" />
            Parameters
          </span>
        </div>
        <div className="ordersContent">
          <div className="ordersArea reportParameters">
            {parameters.map((p) => (
              <div className="formGroup" key={p.name}>
                <div className="row">
                  <div className="col-3">
                    <div className="parameterName">{p.name}</div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-3">
                    <label>Type</label>
                    <div className="selectArea">
                      <select onChange={(e) => this.onParameterTypeChange(p, e)} value={p.type}>
                        {Object.keys(OracleDbType).map((type) => (
                          <option key={type} value={type}>
                            {type}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-5">
                    <label>Value</label>
                    {this.parameterValueSelector(p)}
                  </div>
                  <div className="col-4">
                    <label>Security type</label>
                    <div className="selectArea">
                      <select
                        onChange={(e) => this.onParameterSecurityChange(p, e.target.value)}
                        value={p.securityType ?? ''}
                      >
                        <option key="none" value={''}>
                          None
                        </option>
                        <option key="customer" value="Customer">
                          Customer
                        </option>
                        <option key="rootCustomer" value="RootCustomer">
                          Root Customer
                        </option>
                        <option key="unit" value="Unit">
                          Unit
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </>
    )
  }
  private parameterValueSelector(p: ReportParameterViewModel | ReportParameterInputModel) {
    switch (p.type) {
      case OracleDbType.Date:
        return (
          <DatePicker
            disabled={!!p.securityType}
            popperPlacement="top-start"
            readOnly={false}
            selected={p.value ? new Date(p.value) : undefined}
            onChange={(e) => this.onParameterValueChange(p, (e as Date).toISOString())}
            dateFormat="dd.MM.yyyy"
            locale="en"
          />
        )
      case OracleDbType.Boolean:
        return (
          <div className="selectArea">
            <select onChange={(e) => this.onParameterValueChange(p, e.target.value)} value={p.value ?? ''}>
              <option key="true" value="true">
                True
              </option>
              <option key="false" value="false">
                False
              </option>
              <option key="null" value={''}>
                Null
              </option>
            </select>
          </div>
        )
      default:
        return (
          <input
            disabled={!!p.securityType}
            style={{ height: 'auto' }}
            type="text"
            value={p.value ?? ''}
            name={p.name}
            onChange={(e) => this.onParameterValueChange(p, e.target.value)}
          />
        )
    }
  }

  private onParameterSecurityChange(parameter: ReportParameterViewModel | ReportParameterInputModel, value: string) {
    const updated = this.props.report.parameters.map((p) => {
      return p === parameter ? { ...p, securityType: value || undefined, value: value ? undefined : p.value } : p
    })

    this.props.onChange?.(updated)
  }

  private onParameterValueChange(p: ReportParameterViewModel | ReportParameterInputModel, value: string) {
    const updated = this.props.report.parameters.map((param) => {
      return param === p ? { ...param, value: value || undefined } : param
    })
    this.props.onChange?.(updated)
  }

  private onParameterTypeChange(
    param: ReportParameterViewModel | ReportParameterInputModel,
    e: React.ChangeEvent<HTMLSelectElement>
  ) {
    const updated = this.props.report.parameters.map((p) => {
      return param === p
        ? { ...p, type: e.target.value as OracleDbType, value: p.securityType ? undefined : p.value }
        : p
    })
    this.props.onChange?.(updated)
  }
}

export default ReportParameters
